import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Server, Database, Package, Layers, MapPin, Printer, HardDrive, GitBranch, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

function fmtDT(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("it-IT"); } catch { return iso; }
}
function relative(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "adesso";
  if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
  return `${Math.floor(diff / 86400)} g fa`;
}

export default function AdminSystem() {
  const [s, setS] = useState(null);
  const load = async () => setS((await api.get("/admin/system-status")).data);
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);
  if (!s) return <div className="p-8 text-ink-500">Caricamento…</div>;

  return (
    <div data-testid="admin-system-page">
      <div className="eyebrow">Stato sistema</div>
      <div className="flex justify-between items-start">
        <h1 className="text-4xl mt-1">Sistema</h1>
        <Button variant="outline" onClick={load} className="rounded-full" data-testid="system-refresh"><RefreshCw className="w-4 h-4 mr-1" />Aggiorna</Button>
      </div>
      <p className="text-sm text-ink-500 mt-1">Pagina di sola lettura · aggiornamento automatico ogni 15s</p>

      <div className="grid gap-3 mt-6 sm:grid-cols-2 lg:grid-cols-3">
        <Card testid="sys-print-service" icon={<Printer />} title="Print Service">
          <Row label="Ultima stampa" value={fmtDT(s.last_print_at)} sub={relative(s.last_print_at)} />
          <Row label="Ultimo ordine" value={fmtDT(s.last_order_at)} sub={relative(s.last_order_at)} />
          <Row label="Ordini oggi" value={s.counts.orders_today} />
        </Card>

        <Card testid="sys-db" icon={<Database />} title="Database">
          <Row label="Nome" value={s.database.db_name} />
          <Row label="MongoDB" value={`v${s.database.version}`} />
        </Card>

        <Card testid="sys-app" icon={<GitBranch />} title="Applicazione">
          <Row label="Versione" value={s.app.version} mono />
          <Row label="Ambiente" value={s.app.env || "preview"} />
          <Row label="Server time" value={fmtDT(s.server_time)} />
        </Card>

        <Card testid="sys-content" icon={<Package />} title="Contenuti menu">
          <Row label="Prodotti" value={s.counts.products} />
          <Row label="Categorie" value={s.counts.categories} />
        </Card>

        <Card testid="sys-stations" icon={<MapPin />} title="Postazioni & QR">
          <Row label="Postazioni totali" value={s.counts.stations} />
          <Row label="Attive" value={s.counts.stations_active} />
        </Card>

        <Card testid="sys-backup" icon={<HardDrive />} title="Backup">
          <Row label="Ultimo backup" value={s.last_backup || "—"} mono />
          <p className="text-[11px] text-ink-500 mt-2">Cartella: /app/backups/</p>
        </Card>
      </div>
    </div>
  );
}

function Card({ testid, icon, title, children }) {
  return (
    <div className="card-elevated p-4" data-testid={testid}>
      <div className="flex items-center gap-2 text-bronze-700 mb-2">
        <span className="w-4 h-4">{icon}</span>
        <b>{title}</b>
      </div>
      <div className="space-y-1.5 text-sm">{children}</div>
    </div>
  );
}
function Row({ label, value, sub, mono }) {
  return (
    <div className="flex justify-between items-baseline gap-2">
      <span className="text-ink-500 text-xs">{label}</span>
      <span className={`${mono ? "font-mono text-xs" : ""} text-right`}>
        <b>{value}</b>
        {sub && <span className="text-[10px] text-ink-500 ml-1">({sub})</span>}
      </span>
    </div>
  );
}
